import { SortDirection } from "@mui/material"
import { SortItem } from "lib/api"
import { Variant } from "lib/enum"

interface sortEnumType {
	Desc: string
	Asc: string
}

export class SortEnum extends Variant<sortEnumType> {
	MakeSortItem(): SortItem[] {
		return [
			{
				property: this.Data,
				direction: this.Tag.ToUpper() as "ASC" | "DESC",
			},
		]
	}
	ToMuiSort(): SortDirection {
		return this.Tag.ToLower() as "asc" | "desc"
	}
}

export function Desc(field: string) {
	return new SortEnum("Desc", field)
}

export function Asc(field: string) {
	return new SortEnum("Asc", field)
}
